// Transforms string-specified logic in
// a user's custom config into arrow functions

// Takes a "partially stringified" config as a param.
// Returns a properly formatted config
export default function evalConfig(config) {
  // Hardcoded to indicate which passes currently have "selectionRulesByIntervention" properties
  const passKeysToEval = ["pass2","pass4","pass5"];
  passKeysToEval.forEach(pass => {
    let passToEval = config[pass];
    Object.entries(passToEval.selectionRulesByIntervention).map(([interventionType,ruleData]) => {
      Object.entries(ruleData).forEach(([ruleType, logic]) => {
        let logicAsFunc = eval(logic);
        config[pass].selectionRulesByIntervention[interventionType][ruleType] = logicAsFunc;
      });
    });
  });
  return config;
}